export default "__VITE_ASSET__7644d822__"